import { FrontUrls } from 'Constants/FrontUrls'
import React, { lazy } from 'react'
import { Route, Switch } from 'react-router-dom'
import {
	MonitoringRoutes,
	MerchantStatusRoutes,
	SettingRoutes,
	AgreementsRoutes,
	LandingRoutes,
	FakeResponsesRoutes,
	TemplateRoutes,
	ProductOrderStatusesRoutes,
	ServiceNotificationsRoutes,
	TagsRoutes,
} from 'Pages/admin'
import { LazyRoute } from 'Modules'

const SmsSettingsContainerLazy = lazy(
	() => import('Pages/som/smsSettings/components/SmsSettings/index')
)
const SmsContainerLazy = lazy(() => import('Pages/som/sms/components/index'))

export const AdminPanelRoutes = () => {
	return (
		<Switch>
			<Route
				path={FrontUrls.admin_panel.monitoring}
				key={FrontUrls.admin_panel.monitoring}
				component={MonitoringRoutes}
			/>
			<Route
				path={FrontUrls.admin_panel.merchant_status}
				component={MerchantStatusRoutes}
				key={FrontUrls.admin_panel.merchant_status}
			/>
			<Route
				path={FrontUrls.admin_panel.setting}
				key={FrontUrls.admin_panel.setting}
				component={SettingRoutes}
			/>
			<Route
				path={FrontUrls.admin_panel.lead}
				key={FrontUrls.admin_panel.lead}
				component={AgreementsRoutes}
			/>
			<Route
				path={FrontUrls.admin_panel.landings}
				component={LandingRoutes}
				key={FrontUrls.admin_panel.landings}
			/>
			<LazyRoute
				path={FrontUrls.admin_panel.sms_settings}
				key={FrontUrls.admin_panel.sms_settings}
				lazyComponent={SmsSettingsContainerLazy}
			/>
			<LazyRoute
				path={FrontUrls.admin_panel.sms}
				key={FrontUrls.admin_panel.sms}
				lazyComponent={SmsContainerLazy}
			/>
			<Route
				component={FakeResponsesRoutes}
				path={FrontUrls.admin_panel.fake_responses_index}
				key={FrontUrls.admin_panel.fake_responses_index}
			/>
			<Route
				component={TemplateRoutes}
				path={FrontUrls.admin_panel.template}
				key={FrontUrls.admin_panel.template}
			/>
			<Route
				path={FrontUrls.admin_panel.product_order_statuses}
				key={FrontUrls.admin_panel.product_order_statuses}
				component={ProductOrderStatusesRoutes}
			/>
			<Route
				path={FrontUrls.admin_panel.notifications}
				key={FrontUrls.admin_panel.notifications}
				component={ServiceNotificationsRoutes}
			/>
			<Route
				path={FrontUrls.admin_panel.tags}
				component={TagsRoutes}
				key={FrontUrls.admin_panel.tags}
			/>
		</Switch>
	)
}
